{
  "nav": {
    "home": "Accueil",
    "scouting": "Recrutement",
    "reports": "Rapports",
    "settings": "Paramètres"
  },
  "settings": {
    "language": "Langue",
    "languageDescription": "Choisissez la langue utilisée dans toute l'application.",
    "save": "Enregistrer"
  },
  "reports": {
    "title": "Rapports de recrutement",
    "empty": "Aucun rapport pour l'instant",
    "generateSummary": "Générer un résumé",
    "translationUnavailable": "Traduction indisponible. Le rapport original est affiché.",
    "retryTranslation": "Réessayer",
    "matchesHeading_one": "Match :",
    "matchesHeading_other": "Matchs :",
    "matchLineHome": "contre {{opponent}} le {{date}}",
    "matchLineAway": "à {{opponent}} le {{date}}",
    "matchLineNeutral": "{{opponent}} le {{date}}",
    "editorTitle": "Modifier le rapport de recrutement",
    "untitled": "Rapport",
    "authorSelf": "Vous",
    "sharedBadge": "Partagé",
    "shareAction": "Partager",
    "sharedAction": "Partagé",
    "back": "Retour",
    "editedBy": "Modifié par",
    "createdBy": "Créé par",
    "translate": "Traduire",
    "translating": "Traduction...",
    "showOriginal": "Voir l'original",
    "download": "Télécharger",
    "downloading": "Téléchargement...",
    "edit": "Modifier",
    "archive": "Archiver"
  },
  "language": {
    "control": "Langue",
    "selectTitle": "Sélectionner la langue",
    "change": "Changer de langue",
    "changeCurrent": "Changer de langue, actuellement {{language}}",
    "changeStranded": "Changer de langue. Votre langue enregistrée {{code}} n'est plus proposée, {{language}} est donc utilisée à la place.",
    "generate": "Générer · {{language}}",
    "generateAccessibility": "Langue du résumé généré",
    "saveDefault": {
      "idle": "Enregistrer comme langue par défaut",
      "saving": "Enregistrement…",
      "saved": "Enregistrée comme votre langue par défaut",
      "alreadyDefault": "C'est déjà votre langue par défaut",
      "error": "Échec de l'enregistrement — appuyez pour réessayer",
      "warning": "S'applique uniquement à ce résumé. Enregistrez-la comme langue par défaut, sinon vous devrez le régénérer la prochaine fois.",
      "errorAccessible": "{{label}}. {{reason}}",
      "failed": "Impossible d'enregistrer votre langue par défaut. Veuillez réessayer."
    }
  }
}
